// @flow
import React from 'react';
import {Text, Caption} from 'sail/Text';
import {ButtonLink} from 'sail/Button';
import Box from 'sail/Box';
import Menu, {MenuItem} from 'sail/Menu';
import Icon from 'sail/Icon';
import {chevronDown} from 'sail/Icon/Assets';
import Group from 'sail/Group';
import FlagIcon, {FLAG_COUNTRY_CODES} from 'sail/FlagIcon';
import DeviceIcon from 'sail/DeviceIcon';

type DropdownProps = {|
  label: string,
  value: string,
  onChange: Function,
  optionMap: {},
|};

type DropdownInfoBoxProps = {|
  title: string,
  body: string,
  width: string,
|};

function DropdownInfoBox({title, body, width}: DropdownInfoBoxProps) {
  return (
    <Box
      divider={{side: 'top', color: 'light'}}
      padding={{top: 12, bottom: 12, left: 12, right: 12}}
      style={{width}}
      margin={{top: 8}}
    >
      <Group spacing={8} direction="horizontal" alignItems="baseline">
        <Icon icon="info" color="gray" size={12} />
        <Text color="gray500" lineHeight={20} weight="medium">
          {title}
        </Text>
      </Group>
      <Box padding={{top: 8, left: 20}}>
        <Caption>{body}</Caption>
      </Box>
    </Box>
  );
}

export default function Dropdown({
  label,
  value,
  onChange,
  optionMap,
}: DropdownProps) {
  const itemData: Array<any> = Object.values(optionMap);
  if (itemData[0] && itemData[0].sortingWeight) {
    itemData.sort((a, b) => a.sortingWeight - b.sortingWeight);
  }

  const items = itemData.map((d) => (
    <MenuItem key={d.key} onClick={(e) => onChange(d.key)}>
      <Group direction="horizontal" spacing={8} alignItems="center">
        <Icon
          icon="check"
          size={12}
          color={value === d.key ? 'selected' : 'white'}
        />
        {label === 'Customer location' && (
          <FlagIcon countryCode={FLAG_COUNTRY_CODES[d.key.toUpperCase()]} />
        )}
        {d.label}
      </Group>
    </MenuItem>
  ));

  if (label === 'Customer location') {
    items.push(
      <DropdownInfoBox
        title="Every country pays differently"
        body="The Payment Element supports 135+ currencies. Only a sample is shown here. Stripe automatically reorders payment methods to increase potential conversion."
        width="250px"
      />,
    );
  }

  if (label === 'Theme') {
    items.push(
      <DropdownInfoBox
        title="Customize it"
        body="Create a theme to match your brand with the Appearance API."
        width="185px"
      />,
    );
  }

  return (
    <Group direction="horizontal" alignItems="center" spacing={8}>
      <Text weight="medium" color="gray" lineHeight={20} size={14}>
        {label}
      </Text>
      <Group direction="horizontal" alignItems="center" spacing={4}>
        {label === 'Customer location' && (
          <FlagIcon countryCode={FLAG_COUNTRY_CODES[value.toUpperCase()]} />
        )}
        {label === 'Size' && <DeviceIcon deviceType={optionMap[value].key} />}
        <Menu items={items}>
          <ButtonLink
            label={optionMap[value].label}
            icon={chevronDown}
            iconPosition="right"
          />
        </Menu>
      </Group>
    </Group>
  );
}
